import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { Quotation } from "services/cms/models/quotation";

export type ResolvedQuotation = {
    codename: string;
    type: ContentTypeCodenames.Quotation;
    text: string;
    color: string;
    fontSize: number;
    isBold: boolean;
    isUnderlined: boolean;
    isItalic: boolean;
    author?: string;
};

const quotationResolver = (item: Quotation) => {
    const { text, colour, fontSize, style, authorOfQuote } = item.elements;

    const appliedStyles = style.value.map((s) => s.codename);

    return {
        codename: item.system.codename,
        type: ContentTypeCodenames.Quotation,
        text: text.value,
        color: colour.value,
        fontSize: fontSize.value,
        isBold: appliedStyles.includes("bold"),
        isUnderlined: appliedStyles.includes("underline"),
        isItalic: appliedStyles.includes("italic"),
        author: authorOfQuote?.value,
    };
};

export default quotationResolver;
